import { render, staticRenderFns } from "./BusinessRulePendenciesModal.vue?vue&type=template&id=2b1949cd&scoped=true&"
import script from "./BusinessRulePendenciesModal.vue?vue&type=script&lang=js&"
export * from "./BusinessRulePendenciesModal.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRulePendenciesModal.vue?vue&type=style&index=0&id=2b1949cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1949cd",
  null
  
)

export default component.exports